import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
// import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

import WorkDetailsContainer from '../container/Work/WorkDetailsContainer';


const Gallery = () => {
  return (
    <React.Fragment>
      <SEO title="Gallery | ICSI 2025" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Gallery"
        content="For Participants"
        contentTwo="Gallery"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      {/* <EmptyTwo> */}
        {/* <div className="entry-content2"> */}
          {/* <div className="ch-lang-en">
          <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/Gallery_zn"}>Chinese</Link>
          </div> */}
          {/* <div className="space-50"></div> */}
          {/* <h2>Wonderful Moments</h2> */}
          <WorkDetailsContainer />
          
        {/* </div> */}
      {/* </EmptyTwo> */}

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Gallery;
